import { customElement } from "./CustomElement";

import "../scroll-timeline.js";

@customElement("gct-snap-tabs")
export class SnapTabs extends HTMLElement {

	constructor() {
		super();

		/** @type {HTMLElement} */
		this.section = null;
		/** @type {HTMLElement} */
		this.nav = null;
		/** @type {readonly HTMLAnchorElement[]} */
		this.navItems = Object.freeze([]);
		/** @type {HTMLSpanElement} */
		this.indicator = null;

		/** @type {any} */
		this.scrollTimeline = undefined;
		/** @type {number | undefined} */
		this.scrollEndTimer = undefined;

		this.setup = this.setup.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onScroll = this.onScroll.bind(this);
		this.determineActiveTabSection = this.determineActiveTabSection.bind(this);
	}

	setup() {
		const { matches: motionAllowed } = window.matchMedia("(prefers-reduced-motion: no-preference)");

		this.section = this.querySelector("section");
		this.nav = this.querySelector("header > nav");
		this.navItems = Array.from(this.nav.querySelectorAll("a"));
		this.indicator = this.querySelector(".gct-snap-indicator");

		this.scrollTimeline = new ScrollTimeline({
			scrollSource: this.section,
			orientation: "inline",
			fill: "both",
		});

		this.scrollEndTimer = undefined;

		this.navItems.forEach((item) => {
			item.animate({
				fontWeight: this.navItems.map((i) => i === item ? "600" : "normal"),
			}, {
				duration: 100,
				fill: "both",
				timeline: this.scrollTimeline,
			});
		});

		if (motionAllowed) {
			this.indicator.animate({
				transform: this.navItems.map((i) => `translateX(${i.offsetLeft}px)`),
				width: this.navItems.map((i) => `${i.offsetWidth}px`),
			}, {
				duration: 100,
				fill: "both",
				timeline: this.scrollTimeline,
			});
		}

		this.nav.addEventListener("click", this.onClick);
		this.section.addEventListener("scroll", this.onScroll);

		this.determineActiveTabSection();
	}

	connectedCallback() {
		setTimeout(this.setup);
	}

	disconnectedCallback() {
		this.nav.removeEventListener("click", this.onClick);
		this.section.removeEventListener("scroll", this.onScroll);
	}

	/** @param {MouseEvent} event */
	onClick(event) {
		if (event.target.nodeName !== "A") return;
		event.preventDefault();
		this.setActiveTab(event.target);
	}

	onScroll() {
		clearTimeout(this.scrollEndTimer);
		this.scrollEndTimer = setTimeout(this.determineActiveTabSection, 100);
	}

	/** @param {HTMLAnchorElement} navItem */
	setActiveTab(navItem) {
		this.querySelector("a[active]")?.removeAttribute("active");
		navItem.setAttribute("active", "");

		const sectionId = navItem.getAttribute("href").replace('#', '');
		const sectionElement = this.section.querySelector(`#${sectionId}`);

		if (sectionElement) {
			const scrollPosition = sectionElement.offsetLeft;
			this.section.scrollTo({
				left: scrollPosition,
				behavior: "smooth",
			});
		}
	}

	determineActiveTabSection() {
		const i = this.section.scrollLeft / this.section.clientWidth;
		const navItem = this.navItems[i];

		if (navItem !== undefined) {
			this.setActiveTab(navItem);
		}
	}
}
